import PropTypes from "prop-types";
import { useEffect, useState, Fragment } from "react";
import { NumericFormat } from "react-number-format";
import { TextField } from "@mui/material";
import {
  NUMBER_INPUT_DEFAULT_WIDTH,
  textFieldDefaults,
} from "../formControlDefaults.js";

NumberInput.propTypes = {
  item: PropTypes.object.isRequired,
  value: PropTypes.any,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  showErrorText: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
};

export default function NumberInput(props) {
  const {
    item,
    value,
    error = null,
    onChange,
    showErrorText = false,
    disabled = false,
    readOnly = false,
  } = props;
  const [localValue, setLocalValue] = useState(value);

  const isFullWidth = item?.full_width === true || item?.input_width === "100%";
  const inputWidth =
    item?.input_width ?? (isFullWidth ? "100%" : NUMBER_INPUT_DEFAULT_WIDTH);

  const handleInputChange = (newValue) => {
    setLocalValue(newValue.floatValue);
  };

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleBlur = () => {
    let newValue = localValue;
    if (newValue !== "undefined") {
      if (newValue < item.min) newValue = item.min;
      if (newValue > item.max) newValue = item.max;
    } else newValue = item.default;
    setLocalValue(newValue);
    onChange({ target: { name: item.name, value: newValue } });
  };

  let helperText = "Pflichtfeld";
  if (showErrorText) helperText = error;

  const getInputField = () => {
    const muiTextfieldProps = {
      ...textFieldDefaults,
      label: item.label,
      fullWidth: isFullWidth,
      sx: {
        width: inputWidth,
        maxWidth: "100%",
      },
      InputProps: {
        ...(readOnly && { readOnly: true }),
        sx: {
          "& input": {
            textAlign: "right",
          },
        },
      },
      ...(error && {
        error: true,
        helperText: helperText,
      }),
    };

    switch (item.unit_type) {
      case "currency_no_digit":
        return (
          <NumericFormat
            disabled={disabled}
            allowNegative={true}
            value={localValue}
            onValueChange={handleInputChange}
            onBlur={handleBlur}
            suffix={" " + item.unit}
            thousandsGroupStyle="thousand"
            decimalSeparator=","
            thousandSeparator="."
            customInput={TextField}
            {...muiTextfieldProps}
          />
        );
      case "currency":
        return (
          <NumericFormat
            disabled={disabled}
            allowNegative={item.allow_negative}
            value={localValue}
            onValueChange={handleInputChange}
            onBlur={handleBlur}
            suffix={" " + item.unit}
            decimalScale={2}
            thousandsGroupStyle="thousand"
            decimalSeparator=","
            thousandSeparator="."
            customInput={TextField}
            {...muiTextfieldProps}
          />
        );
      case "percent":
        return (
          <NumericFormat
            disabled={disabled}
            allowNegative={true}
            decimalScale={2}
            value={localValue}
            decimalSeparator=","
            onValueChange={handleInputChange}
            onBlur={handleBlur}
            suffix={" " + item.unit}
            customInput={TextField}
            {...muiTextfieldProps}
          />
        );
      case "integer":
        return (
          <NumericFormat
            disabled={disabled}
            allowNegative={true}
            thousandSeparator="."
            decimalSeparator=","
            value={localValue}
            onValueChange={handleInputChange}
            onBlur={handleBlur}
            suffix={" " + item.unit}
            customInput={TextField}
            {...muiTextfieldProps}
          />
        );
      default:
    }
  };

  return <Fragment>{getInputField()}</Fragment>;
}
